import React from 'react'
import './Loader.css'

function Loader({isVisible, isFull = false}){
	return (
        <div className="loader">
            <div className="dot-falling"></div>
        </div>
	)
}

export default Loader